var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#1BACE4",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 6,
    x: 8.25,
    y: 17.25,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.875C12.2071068 19.875 12.375 20.0428932 12.375 20.25M11.625 20.25C11.625 20.0428932 11.7928932 19.875 12 19.875M12 20.625C11.7928932 20.625 11.625 20.4571068 11.625 20.25M12.375 20.25C12.375 20.4571068 12.2071068 20.625 12 20.625M15.75 19.875C15.9571068 19.875 16.125 20.0428932 16.125 20.25M15.375 20.25C15.375 20.0428932 15.5428932 19.875 15.75 19.875M15.75 20.625C15.5428932 20.625 15.375 20.4571068 15.375 20.25M16.125 20.25C16.125 20.4571068 15.9571068 20.625 15.75 20.625M19.5 19.875C19.7071068 19.875 19.875 20.0428932 19.875 20.25M19.125 20.25C19.125 20.0428932 19.2928932 19.875 19.5 19.875M19.5 20.625C19.2928932 20.625 19.125 20.4571068 19.125 20.25M19.875 20.25C19.875 20.4571068 19.7071068 20.625 19.5 20.625M21.75 17L21.75 12.75C21.75 11.9215729 21.0784271 11.25 20.25 11.25L18.75 11.25C17.9215729 11.25 17.25 10.5784271 17.25 9.75L17.25 8.25C17.25 7.42157288 16.5784271 6.75 15.75 6.75L11.25 6.75C10.4215729 6.75 9.75 7.42157288 9.75 8.25L9.75 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1 11.081L1.359 4.708C.515250233 3.77057612.553042231 2.33667738 1.445 1.445L1.445 1.445C2.33667738.553042231 3.77057612.515250233 4.708 1.359L10.781 6.825M6 15.75C6.41421356 15.75 6.75 16.0857864 6.75 16.5 6.7450578 18.1548028 5.4048028 19.4950578 3.75 19.5L3.75 19.5C2.0951972 19.4950578.754942202 18.1548028.75 16.5L.75 15.75 6 15.75zM.75 3.194L.75 15.75M4.505 8.203L3.75 15.75M9.75 12.75L13.629 12.75C14.0265472 12.7499151 14.4078016 12.5920182 14.689 12.311L17.25 9.75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoval);
export default __webpack_public_path__ + "static/media/removal.22fe7be67981fa8ce2ebd5722846b64a.svg";
export { ForwardRef as ReactComponent };